import React, { useEffect, useRef } from "react";
import Text from "../../../components/ui/Text";
import { MedicalItemType } from "./BodyPartsStats";

interface Props {
  item: MedicalItemType;
}

const MedicalItemRow = ({ item }: Props) => {
  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    function onDragOver(e: DragEvent) {
      e.preventDefault();
    }
    document.body.addEventListener("dragover", onDragOver);

    return () => document.body.removeEventListener("dragover", onDragOver);
  }, []);

  function onDragStart(e: React.DragEvent<HTMLDivElement>) {
    e.dataTransfer.setData("text/plain", JSON.stringify(item));
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.dropEffect = "move";

    if (imgRef.current) {
      const img = imgRef.current;
      e.dataTransfer.setDragImage(img, img.width / 2, img.height / 2);
    }
  }

  return (
    <div
      className="flex items-center min-w-[320px] cursor-grab"
      draggable
      onDragStart={onDragStart}
    >
      <img
        ref={imgRef}
        src={item.image}
        alt="Medical"
        style={{
          filter: "drop-shadow(12px -4px 20px rgba(255,255,255,0.3))",
        }}
        className="object-contain w-full h-full max-w-[85px] z-[2] relative"
      />

      <div
        style={{
          background:
            "linear-gradient(48deg,rgba(153, 153, 153, 0.01) 0%, rgba(255, 255, 255, 0.14) 100%)",
        }}
        className="rounded-md p-3 h-full w-full max-h-[75px] ml-[-25px] pl-10 z-[-1]"
      >
        <Text size="xs" className="text-white font-semibold">
          {item.name}
        </Text>
        <Text size="xxs" className="text-white/55">
          {item.description}
        </Text>
      </div>
    </div>
  );
};

export default MedicalItemRow;
